var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:[_vm.disabled ? 'disabled' : '', 'maf-btn'],style:(_vm.btnStyle),attrs:{"disabled":_vm.disabled},domProps:{"innerHTML":_vm._s(_vm.name)},on:{"click":function($event){$event.stopPropagation();return _vm.actionFunc($event)}}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c16fe300","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MafButton.vue
// module id = null
// module chunks = 